import { PropsWithChildren } from 'react';
import {
  Accordion,
  AccordionItem,
} from '@client/new/components/Accordion/Accordion';
import { Typography } from '@design-system/components/typography/typography';
import { groupWrapper } from './Group.css';
import { Col } from '@design-system/components/grid/grid';
import { sprinkles } from '@design-system/sprinkles.css';

export const Group = (p: PropsWithChildren<{ title: string }>) => (
  <div className={groupWrapper}>
    <Accordion initialActiveIndexes={0}>
      <AccordionItem
        title={
          <Typography variant="body" size="large" fontWeight="medium">
            {p.title}
          </Typography>
        }
      >
        <Col className={sprinkles({ gap: 'l', paddingTop: '0' })}>
          {p.children}
        </Col>
      </AccordionItem>
    </Accordion>
  </div>
);
